<template>
  <v-app>
    <v-app-bar app clipped-left color="#1e2028" dark fixed>
      <v-toolbar-title style="width:200px" class="ml-0 pl-3">
        <a href="http://www.unryo.com/">
          <img class="icon logo" src="./assets/logo.svg" width="120" />
        </a>
      </v-toolbar-title>
      <v-toolbar-items>
        <v-btn text to="/overview">{{ $t('overview') }}</v-btn>
        <v-btn text to="/topology">{{ $t('topology') }}</v-btn>
        <v-btn text to="/geomap">{{ $t('geomap') }}</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn color="accent" to="/start">{{ $t('start') }}</v-btn>
        <v-btn text @click="openWizard">
          <template>
            <v-icon>add</v-icon>
            {{ $t('deploy') }}
          </template>
        </v-btn>
        <v-btn text to="/integrations">{{ $t('integrations') }}</v-btn>
        <v-btn text :href="doc" target="_blank">
          <v-icon dark>help_outline</v-icon>
        </v-btn>
        <v-menu offset-y bottom left>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <span>{{ username }}</span>
              <v-icon dark>arrow_drop_down</v-icon>
            </v-btn>
          </template>
          <v-list subheader>
            <v-list-item to="/tokens">
              <v-list-item-title>{{ $t('tokens') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout()">
              <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-container fluid fill-height class="pa-6">
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-container>
      <app-welcome v-if="welcome" @complete="welcomeComplete()"></app-welcome>
      <app-deploy :open="deploy" @close="closeWizard"></app-deploy>
    </v-content>
    <div ref="messages"></div>
  </v-app>
</template>

<script>
import AuthenticationService from '@/services/authentication'
import MessageService from '@/services/message'
import DeployComponent from '@/components/Deploy.vue'
import WelcomeComponent from '@/components/welcome/Welcome.vue'
import { docsUrl } from '@/services/docs'

const onboarding = 'https://unryo.com/onboarding'

export default {
  name: 'App',
  data () {
    return {
      deploy: false,
      doc: docsUrl('introduction')
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    username () {
      const user = this.user
      return user && user.name
    },
    welcome: {
      get () {
        const user = this.user
        return user && !user[onboarding]
      },
      set () {
        const user = this.user
        if (user) {
          user[onboarding] = true
        }
      }
    }
  },
  mounted () {
    MessageService.setContainer(this.$refs.messages)
  },
  methods: {
    logout () {
      AuthenticationService.logOut()
    },
    welcomeComplete () {
      this.welcome = true
    },
    openWizard () {
      this.deploy = true
      this.$root.$emit('wizardOpen', 'The wizard is now active.')
    },
    closeWizard () {
      this.deploy = false
      this.$root.$emit('wizardClose', 'The wizard is now closed.')
    }
  },
  components: {
    'app-welcome': WelcomeComponent,
    'app-deploy': DeployComponent
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  box-shadow: none !important;
  border-radius: 0;
}

.v-menu__content, .v-list {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>

<i18n>
{
  "en": {
    "overview": "Overview",
    "topology": "Topology",
    "tokens": "Tokens",
    "geomap": "GeoMap",
    "integrations": "Integrations",
    "start": "Start Here",
    "deploy": "Deploy",
    "logout": "Logout"
  }
}
</i18n>
